import Gallery from "pages/community/gallery";

export default function JoinCommunityCta() {
    return (
        <section className="join-community py-10 px-6 lg:px-16">
            <h1 className="text-left max-w-2xl lg:max-w-sm text-3xl lg:text-5xl pt-4 lg:pt-6 tracking-normal font-medium">
                Want to Join Our <span className="font-serif italic text-secondary font-semibold"> Community?</span></h1>
            <p className="lg:max-w-xl py-3 lg:py-5 text-text-color text-base font-medium ">Come connect with ambitious women like you — learning, growing, and winning together with Shecluded by your side.</p>
            <a href="https://chat.whatsapp.com/KNjaEnbf4zl5NFRKcTrsLW" className="inline-flex items-center rounded-full bg-text-color py-3 px-20 text-sm/6 lg:text-base font-medium text-light-grey-4 drop-shadow-lg  transition duration-0 ease-in hover:drop-shadow-xl hover:duration-150">
                Join Now
            </a>
            <hr className='my-8 border-1 border-light-grey-1 mr-20'></hr>
            <Gallery />
        </section>
    )
}

